import type { ModalFuncProps } from 'antd';
import css from './index.module.scss';
import EfModal from '@/components/UI/Modal';
import { useGlobal } from '@/utils/useGlobal';

interface props extends ModalFuncProps {
    tKey: string;
}
export default function Mm100Popup({ visible, tKey = 'ecoflowpowerkits', onCancel }: props) {
    const { isMobile, useEffect, Link, useLang } = useGlobal();
    const { t } = useLang(tKey);
    const getDataLayer = () => {
        return {
            event: 'uaEvent',
            event_name: 'activity_join',
            button_name: 'join_now',
        };
    };
    useEffect(() => {
        if (isMobile && visible) {
            document.documentElement.style.overflowY = 'hidden';
        }
        return () => (document.documentElement.style.overflowY = '');
    }, []);
    return (
        <EfModal visible={visible} onCancel={onCancel} width={924} className={css.popup} maskStyle={{ backgroundColor: 'rgba(0, 0, 0, .6)' }}>
            <h5 className="popup-title">{t('preview.popup_title')}</h5>
            <div className="popup-text">{t('preview.popup_content')}</div>
            <Link href="https://www.facebook.com/groups/efpowerkits" dataLayer={getDataLayer()}>
                <button className="popup-btn">{t('preview.popup_btn_text')}</button>
            </Link>
        </EfModal>
    );
}
